document.addEventListener('click', (event) => {
  const target = /** @type {HTMLElement} */ (event.target);
  const link = target.closest('a');

  if (!link || !link.hash) return;

  const isSameOrigin = link.origin === window.location.origin;
  const isSamePath = link.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');

  if (!isSameOrigin || !isSamePath) return;

  const dialogId = link.hash.substring(1);
  const dialogComponent = document.getElementById(dialogId);

  if (dialogComponent && typeof /** @type {any} */ (dialogComponent).showDialog === 'function') {
    event.preventDefault();
    /** @type {any} */ (dialogComponent).showDialog();
  }
});
